import React from 'react';
export var SubMenuContext = React.createContext({});
//# sourceMappingURL=sub-menu-context.js.map